var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 77,
    viewBox: "0 0 111 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-555 -4939)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.5 4940.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.885,70.5h-35A5.385,5.385,0,0,1,.5,65.115V5.885A5.385,5.385,0,0,1,5.885.5H46.269",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,16.654,18.577.5l8.077,16.154V62.423a8.077,8.077,0,1,1-16.154,0Z",
    transform: "translate(43.846 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x2: 16.154,
    transform: "translate(54.346 48.961)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 70,
    transform: "translate(16.654 0.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x2: 10.769,
    transform: "translate(30.115 19.346)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,45A22.506,22.506,0,0,1,13.742,1.768,22.506,22.506,0,0,1,31.258,43.232,22.359,22.359,0,0,1,22.5,45Zm-.289-27.8h0V30.8h3.528V13h-.378L18,15.637v2.869L22.21,17.2Z",
    transform: "translate(621 4971)",
    fill: "#761ccb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup50);
export default __webpack_public_path__ + "static/media/Group50.9efe3a03.svg";
export { ForwardRef as ReactComponent };